import React, { useState, useEffect, ReactNode, useRef } from "react";
import "../../assets/styles/components/textfield.scss";

interface Props {
  name?: string;
  accept?: string;
  title?: string;
  type?: string;
  placeholder?: string;
  className?: string;
  inputClassName?: string;
  inputStyle?: object;
  elStyle?: object;
  other?: boolean;
  readOnly?: boolean;
  underline?: boolean;
  value?: string;
  disabled?: boolean;
  onBlur?: (event: React.ChangeEvent<HTMLInputElement>) => void;
  customText?: ReactNode;
  onChange?: (event: React.ChangeEvent<HTMLInputElement>) => void;
}

const Input: React.FC<Props> = ({
  name,
  accept,
  placeholder,
  onBlur,
  onChange,
  title,
  type = "text",
  other = false,
  className = "",
  inputClassName = "",
  inputStyle = {},
  elStyle = {},
  value,
  readOnly = false,
  underline = true,
  disabled,
  customText,
}) => {
  const inputRef = useRef<HTMLInputElement>(null);
  let attributes = Object.assign({});
  attributes.className = `${
    other ? "input-other" : !underline ? "input-no-underline" : "input"
  } ${className || ""}`;

  const [isInput, setIsInput] = useState<boolean>(false);
  useEffect(() => {
    if (customText) setIsInput(true);
  }, []);

  useEffect(() => {
    inputRef.current && inputRef.current.focus();
  }, [isInput]);

  const isBlur = () => {
    if (customText) {
      setIsInput(true);
      inputRef.current && inputRef.current.focus();
    }
  };

  const onInput = () => setIsInput(false);
  return (
    <div {...attributes} style={elStyle}>
      <div className="title-input">{title}</div>
      <input
        ref={inputRef}
        name={name}
        accept={accept}
        readOnly={readOnly}
        className={inputClassName}
        style={{ display: !isInput ? "block" : "none", ...inputStyle }}
        type={type}
        placeholder={placeholder}
        onChange={onChange}
        onBlur={onBlur || isBlur}
        value={value}
        disabled={disabled}
      />
      {isInput && (
        <div
          className={inputClassName}
          style={{ height: "40px", ...inputStyle }}
          onClick={() => onInput()}
        >
          {customText}
        </div>
      )}
    </div>
  );
};
export default Input;
